import { CHART_DATA } from '../data/sample-chart-data';
import { CHART_DATA as CHART_DATA_2 } from '../data/sample-chart-data-2';
import { CHART_DATA as STACKED_CHART } from '../data/sample-chart-stacked-data';

interface IDatasets {
  [key: string]: IChartData[];
}
// Stub this for now...

/* tslint:disable:object-literal-sort-keys */
const DATASETS: IDatasets = {
  passengerDistanceTraveled: CHART_DATA,
  vehicleDistanceTraveled: CHART_DATA_2,
  co2Emissions: CHART_DATA,
  pm25Emissions: CHART_DATA,
  modalSplit: STACKED_CHART,
}

export interface IDataPoint {
  x: number | string; // just for the benefit of modalSplit key...
  y: number
}
export interface IChartData {
  id: string;
  color: string;
  data: IDataPoint[];
}

/*
  Helper function that calculates projections for a given metric
  Todo: Make this read from the redux store instead (consume the store as an argument?)

  Key is a string enum:
  passengerDistanceTraveled
  vehicleDistanceTraveled
  co2Emissions
  pm25Emissions
  modalSplit
*/
export const getProjectionTimeseries = (key: string): IChartData[] => {
  return DATASETS[key];
};



// WEBPACK FOOTER //
// ./src/services/projections.ts